import PetConcern from '@/enums/PetConcern';

export default {
  namespaced: true,
  state: {
    petConcerns: [],
  },
  getters: {
    getPetConcerns(state) {
      const { petConcerns } = state;

      // Disable legacy concern still in the backend until we migrate historical data.
      if (petConcerns.some((concern) => concern.value === PetConcern.Skin)) {
        return petConcerns.filter((concern) => concern.value !== PetConcern.SkinAndEar);
      }

      return petConcerns;
    },
    getGuidedSearchPetConcerns(state, getters) {
      // TODO remove legacy 'show_on_guided_search' fallback check
      return getters.getPetConcerns.filter(
        (concern) => concern.is_cx_appointment_concern ?? concern.show_on_guided_search,
      );
    },
    getCollapsedGuidedSearchPetConcerns(state, getters) {
      return getters.getGuidedSearchPetConcerns.filter((concern) => concern.is_primary);
    },
  },
  actions: {
    async fetchPetConcerns({ commit }, payload) {
      await this.$app.$api.get('p/pet/concerns', { params: payload })
        .then((response) => commit('setPetConcerns', response.data.data))
        .catch(() => {});
    },
  },
  mutations: {
    setPetConcerns(state, data) {
      state.petConcerns = data;
    },
  },
};
